import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

import TabView from '@/views/TabView.vue'
import HomeTab from '@/views/tabs/HomeTab.vue'
// import MarketsTab from '@/views/tabs/MarketsTab.vue'
import TradeTab from '@/views/tabs/TradeTab.vue'
import FuturesTab from '@/views/tabs/FuturesTab.vue'
import BalancesTab from '@/views/tabs/BalancesTab.vue'
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import UserView from '@/views/UserView.vue'
import RechargeView from '@/views/RechargeView.vue'
import WithdrawView from '@/views/WithdrawView.vue'
import TransferView from '@/views/TransferView.vue'
import KLineView from '@/views/KLineView.vue'
import KLineView1 from '@/views/KLineView1.vue'
import KLineView2 from '@/views/KLineView2.vue'
import IEOTab from '@/views/tabs/IEOTab.vue'

import { userInfo } from '@/apis'
import { Toast } from 'vant'
import 'vant/es/toast/style'

const userStatus = (next) => {
  userInfo().then(res => {
    if (res.code === 200 && res.data) {
      if (Number(res.data.authState) === 2) {
        next()
        return
      }
      router.push({ name: 'identityAuth' })
    }
  }).catch(() => {
    Toast({ message: 'server error', position: 'bottom' })
  })
}

const routes = [
  {
    path: '/',
    name: 'tab',
    redirect: '/home',
    component: TabView,
    children: [
      {
        path: '/home',
        name: 'home',
        component: HomeTab
      },
      // {
      //   path: '/markets',
      //   name: 'markets',
      //   component: MarketsTab
      // },
      {
        path: '/trade',
        name: 'trade',
        component: TradeTab
      },
      {
        path: '/futures',
        name: 'futures',
        component: FuturesTab
      },
      {
        path: '/balances',
        name: 'balances',
        component: BalancesTab
      },
      {
        path: '/ieo',
        name: 'ieo',
        component: IEOTab,
        beforeEnter: (to, form, next) => {
          if (store.state.token === '') {
            if(to.fullPath != '/ieo' && to.fullPath != '/futures'){
              router.push({ name: 'login' })
              return
            }
          }
          next()
        }
      }
    ]
  },
  {
    path: '/pledge-loan',
    name: 'pledgeLoan',
    component: () => import('@/views/PledgeLoanPage.vue'),
    beforeEnter: (to, from, next) => {
      if (store.state.token === '') {
        next({ name: 'login' })
        return
      }
      next()
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/user',
    name: 'user',
    component: UserView
  },
  {
    path: '/auth/info',
    name: 'authInfo',
    component: () => import('@/views/AuthInfo.vue')
  },
  {
    path: '/app',
    name: 'download',
    component: () => import('@/views/AppDownload.vue')
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: RechargeView,
  },
  {
    path: '/withdraw',
    name: 'withdraw',
    component: WithdrawView,
    beforeEnter: (to, form, next) => {
      userStatus(next)
    }
  },
  {
    path: '/transfer',
    name: 'transfer',
    component: TransferView,
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('@/views/InviteView.vue')
  },
  {
    path: '/order/CT',
    name: 'CTOrder',
    component: () => import('@/views/order/CTOrder.vue')
  },
  {
    path: '/order/SF',
    name: 'SFOrder',
    component: () => import('@/views/order/SFOrder.vue')
  },

  {
    path: '/balance/funding',
    name: 'balanceFunding',
    component: () => import('@/views/balance/FundingView.vue')
  },
  {
    path: '/balance/futures',
    name: 'balanceFutures',
    component: () => import('@/views/balance/FuturesView.vue')
  },
  {
    path: '/balance/presale',
    name: 'balancePreSale',
    component: () => import('@/views/balance/PreSaleView.vue')
  },

  {
    path: '/order/F',
    name: 'FOrder',
    component: () => import('@/views/order/FOrder.vue')
  },
  {
    path: '/order/C',
    name: 'COrder',
    component: () => import('@/views/order/COrder.vue')
  },
  {
    path: '/order/I',
    name: 'IOrder',
    component: () => import('@/views/order/IOrder.vue')
  },
  {
    path: '/balance/history',
    name: 'balanceHistory',
    component: () => import("@/views/BalanceHistory.vue")
  },
  {
    path: '/recharge/history',
    name: 'rechargeHistory',
    component: () => import("@/views/RechargeHistory.vue")
  },
  {
    path: '/withdraw/result',
    name: 'withdrawRes',
    component: () => import("@/views/WithdrawRes")
  },
  {
    path: '/withdraw/history',
    name: 'withdrawHistory',
    component: () => import("@/views/WithdrawHistory.vue")
  },
  {
    path: '/transfer/history',
    name: 'transferHistory',
    component: () => import("@/views/TransferHistory.vue")
  },
  {
    path: '/identity/auth',
    name: 'identityAuth',
    component: () => import('@/views/IdentityAuth.vue')
  },
  {
    path: '/password/manage',
    name: 'passwordManage',
    component: () => import('@/views/PasswordManage.vue')
  },
  {
    path: '/google-auth',
    name: 'googleAuth',
    component: () => import('@/views/GoogleAuth.vue')
  },
  {
    path: '/email/update',
    name: 'emailUpadet',
    component: () => import('@/views/update/LoginEmail.vue')
  },
  {
    path: '/password/update',
    name: 'loginPwd',
    component: () => import('@/views/update/LoginPwd.vue')
  },
  {
    path: '/finance/update',
    name: 'financePwd',
    component: () => import('@/views/update/FinancePwd.vue')
  },
  {
    path: '/kline',
    name: 'kline',
    component: KLineView,
    beforeEnter: (to, form, next) => {
      if (to.query.key === 'WTCUSDT' && store.state.token === '') {
        router.push({ name: 'login' })
        return
      }
      next()
    }
  },
  {
    path: '/kline1',
    name: 'kline1',
    component: KLineView1,
    beforeEnter: (to, form, next) => {
      if (to.query.key === 'WTCUSDT' && store.state.token === '') {
        router.push({ name: 'login' })
        return
      }
      next()
    }
  },
  {
    path: '/kline2',
    name: 'kline2',
    component: KLineView2,
    beforeEnter: (to, form, next) => {
      if (to.query.key === 'WTCUSDT' && store.state.token === '') {
        router.push({ name: 'login' })
        return
      }
      next()
    }
  },
  {
    path: '/bulletin/detail',
    name: 'bulletinDetail',
    component: () => import('@/views/BulletinDetail.vue')
  },
  {
    path: '/bulletin/list',
    name: 'bulletinList',
    component: () => import('@/views/BulletinList.vue')
  },
  {
    path: '/about/us',
    name: 'aboutUs',
    component: () => import('@/views/AboutUs.vue')
  },
  {
    path: '/agree/detail',
    name: 'agree',
    component: () => import('@/views/AgreeView.vue')
  },
  {
    path: '/agree/list',
    name: 'agreeList',
    component: () => import('@/views/AgreeList.vue')
  },
  {
    path: '/ios/download',
    name: 'iosDownload',
    component: () => import('@/views/IosDownload.vue')
  },
  { path: '/:pathMatch(.*)*', redirect: '/home' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 在路由改变前执行
  if (to.name !== from.name) {
    // 只有在路由改变时才重置滚动位置
    window.scrollTo(0, 0);
  }
  next();
});

export default router
